import React, { Component } from 'react'
// import { storeData } from '../../../storeData'

export default class Nosotros extends Component {
  render() {
    const {storeData} = this.props
    return (
      <div className='DefaultPage'>

        <h2>

        Sobre nosotros
        </h2>

        <h2>

¿Que es {storeData.name}?
        </h2>

        <p>
En Fashion, encontrarás moda para todos los gustos, siempre alineada con las últimas tendencias. Nuestra colección es para quien busca estilo y novedad. La moda que todos quieren, en un solo lugar
        </p>

<p>
Despachamos tus pedidos desde Cali, Medellín o Bogotá, Colombia, dependiendo de la ciudad de destino.
</p>

<p>

Contáctanos a contacto@{storeData.domain.split("https://")[1]} para resolver cualquier inquietud. Estamos atentos para atenderte lo más pronto posible.
</p>
      </div>
    )
  }
}
